var moment = require("moment");
import firebase from "@/services/firebase";
import {
  MEMBER_STATUS
} from "@/constants/discussion";
import {
  FIREBASE_ROOT_REF,
  ROOM_TYPE,
  CHAT_MSG_STATUS
} from "../../../constants/discussion";
import {
  mapActions,
  mapGetters
} from "vuex";
import _ from "lodash";
import {
  VuemojiPicker,
  useDatabase
} from 'vuemoji-picker'
import chatService from "../../../services/chat";
import agencyService from "../../../services/agency";
import chat from '@/mixins/chat';
import uploadFile from "../../../mixins/uploadFile";
import { FILE_ERROR, IMAGE_MIME_TYPES } from "../../../constants/variables";
import Utils from "@/mixins/Utils";

// This reference of firebase should be passed from message.js
let rootRef = FIREBASE_ROOT_REF;
let refMessage = `${rootRef}/Messages`;
import vClickOutside from 'v-click-outside'
import { LOG_ACTIVITY_TYPE } from "../../../constants/chat";

export default {
  props: ['info', 'isDisconnected', 'userStatus', 'participantIds','isOpenRoomChat','loadingChatDetail'],
  mixins: [chat, uploadFile, Utils],
  directives: {vClickOutside},
  data() {
    return {
      isFocusSendMessageInput:false,
      message: "",
      indexUnreadMessage: undefined,
      arrayUnreadMessageIndex: [],
      numberUnreadMessage: 0,
      isUserStayThanDurationTime: false,
      alert: {
        message: '',
      },
      showEmojiBox: false,
      isShowReactBox: false,
      isShowMarkUnreadBox: false,
      isFirstNewMessage: false,
      showOptionIndex: null,
      currentMsg: null,
      currentMsgIndex: null,
      confirmPopup: {
        message: '',
        closeBtn: '',
        submitBtn: ''
      },
      currentReactMsgHover: null,
      currentMarkUnreadKey: null,
      currentAction: null,
      previewImgs: [],
      reactArr: [
        "red_heart",
        "laughing",
        "face_with_open_mouth",
        "crying_face",
        "angry",
        "thumbsup",
        "thumbsdown",
      ],
      isShowAgencyBanner: false,
      agencyPhone: null,
      lastMessageKey: null
    }
  },
  components: {
    VuemojiPicker
  },
  watch: {
    info: {
      // the callback will be called immediately after the start of the observation
      immediate: true, 
      handler (val, oldVal) {
        if (val) {
          if(!val.detail.isFirstOpenRoomchat) {
            this.previewImgs = [];
            this.scrollToBottom("chatBox");
            this.isFirstNewMessage = true;
            this.$emit('updateFirstSelectRoom', true);
  
           
          }
         

          if(!val.detail.content){
            this.$set(val.detail, 'content', [])
          }
          this.updateUnreadMessage();
          if(this.info && this.info.detail.unreadConversation && this.info.unreadMessageArray.length> 0 && this.info.isScrollTop===false && this.info.isChangeMessage==false && val.detail.isFirstOpenRoomchat) {
            const currentUnreadMessageKey = this.info.unreadMessageArray[0].key;
            const unreadMessageIndex = this.info.detail.content.findIndex(content => content.key === currentUnreadMessageKey);
            this.scrollToElement(`index-${unreadMessageIndex >2 ? (unreadMessageIndex-2) :(unreadMessageIndex>1?unreadMessageIndex:0)}`);
          }

          if(this.isUserStayThanDurationTime && val && val.detail.isSelectedRoomchat && this.currentMarkUnreadKey ==null && this.isOpenRoomChat) {
            setTimeout(()=> {
             this.onReadMessage();
            },1500)
            
         }
         
          
        }
      }
    },

    isOpenRoomChat: {
      immediate: true, 
      handler(val){
        if(val===true) {
          this.isFirstNewMessage = false;
          this.isUserStayThanDurationTime = false;
          this.currentMarkUnreadKey = null;
          this.updateUnreadMessage();
          this.isUserStayThanDurationTime = false;
          const numberInterval = this.chatSettings && this.chatSettings.durationUnread ? this.chatSettings.durationUnread *1000+10 : 10000;
          setTimeout(()=> {
  
            if(this.info && this.info.detail.isSelectedRoomchat && this.currentMarkUnreadKey ==null) {
                this.onReadMessage();
                this.isUserStayThanDurationTime = true;
          
            }
            },numberInterval)
          if (
            this.info &&
            this.info.detail &&
            this.info.detail.inputMessage
          ) {
            this.message =
            this.info.detail.inputMessage !== null
                ? this.info.detail.inputMessage
                : "";
          } else {
            this.message = "";
          }
        }
      }
    } ,
    chatContent:{
      handler(val){
          if(this.info && this.info.detail.unreadConversation && this.info.unreadMessageArray.length> 0 && this.info.isScrollTop===false  && this.info.isChangeMessage==false) {
          this.currentMarkUnreadKey = this.info.unreadMessageArray[0].key;
          const unreadMessageIndex = this.info.detail.content.findIndex(content => content.key === this.currentMarkUnreadKey);
          this.scrollToElement(`index-${unreadMessageIndex >2 ? (unreadMessageIndex-2) :(unreadMessageIndex>1?unreadMessageIndex:0)}`);
        }
        if(!this.info.isScrollTop || this.info.detail.unreadConversation || this.info.isChangeMessage){
          return;
        }
       
        if((val.length%20==0) && val.length>20) {
          this.scrollToElement(`index-18`);
        } else if((val.length%20) !==0) {
          this.scrollToElement(`index-${val.length%20}`);

        }
      }
    }
  },

  mounted() {
    this.updateUnreadMessage();
    this.getMyAgency();

  },

  destroyed() {
    this.isFirstNewMessage = false;
    this.isUserStayThanDurationTime = false;  },
  computed: {
    ...mapGetters('chat', ['pendingMsgs', 'chatSettings']),
    isAgency() {
      return this.info.detail.type == ROOM_TYPE.AGENCY
    },
    chatBoxHeight() {
      const defaultHeight = 430;
      return this.previewImgs.length ? defaultHeight + 140 : defaultHeight
    },
    roomTitle() {
      const title = this.info.detail.description;
      const mainName = this.info.detail.type == ROOM_TYPE.AGENCY ? this.info.detail.agencyName : this.info.detail.name;
      return mainName + (title ? '-' + title : '');
    },
    participants() {
      return this.info.detail.members.filter(member => member.status == 1);
    },
    

    chatContent() {
      const firebasePath = `${refMessage}/${this.info.detail.idFirebase}`
      const infoContent = this.info.detail.content

      if(!infoContent) {
        return []
      }

      if (this.pendingMsgs[firebasePath]) {
        const userInfo = this.info.detail.members.find(member => member.idFirebase === this.userIdFirebase);
        this.pendingMsgs[firebasePath].forEach(mess => {
          const msgIndex = _.findIndex(infoContent, (content) => content.sentAt === mess.sentAt);
          if (msgIndex === -1) {
            infoContent.push({
              userInfo: userInfo,
              isMine: true,
              ...mess
            })
          }
        });
      }

      infoContent.forEach(content => {
        const reactions = content.reactions;
        if (reactions) {
          Object.keys(content.reactions).forEach(emoji => {
            reactions[emoji] = Object.keys(reactions[emoji]).map(key => {
              return {
                ...reactions[emoji][key],
                key: key
              }
            })
          })
        }
      })

      return infoContent;
    },
    roomId() {
      return this.info.detail.idFirebase;
    },
    userId() {
      return JSON.parse(localStorage.getItem("user")).pkAdv;
    },
    userCrfId() {
      return JSON.parse(localStorage.getItem("user")).pkCrf;
    },
    userInfo() {
      return JSON.parse(localStorage.getItem("user"))
    },
    userIdFirebase() {
      return `usr-${this.userCrfId}`;
    },
    chatMsgStatus() {
      return CHAT_MSG_STATUS;
    },
    reactEmojis() {
      const database = new useDatabase();
      const emojiArr = [];
      this.reactArr.forEach(item => {
        database.getEmojiByShortcode(item).then(res => {
          emojiArr.push(res);
        })
      })
      return emojiArr;
    }
  },
  created() {
    this.getChatSettings();
  },
  methods: {
    handleScroll() {
      this.$emit('loadMoreMessage', false);
      const element = this.$refs.messagesBar;
      const scrollTop = element.scrollTop;
      if (
       scrollTop==0)
       {
        this.$emit('loadMoreMessage', true);
      }
    },
    getMyAgency() {
      agencyService
         .getAgence()
         .then((res) => {
             if(res && res.data.agency) {
                 this.agency = res.data.agency || {};
                const d = new Date();
                const day = d.getUTCDay();
                const timeOpenAgency = this.agency.horairesAgence || [];
                this.agencyPhone = this.agency.tel;
                this.isShowAgencyBanner = false;
                switch(day) {
                  case 0: {
                     if(timeOpenAgency['dimanche']) {
                       this.checkDisplayAgencyBanner(timeOpenAgency['dimanche'].start,timeOpenAgency['dimanche'].end)
                     }
                     break;
                  }

                  case 1: {
                     if(timeOpenAgency['lundi']) {
                       this.checkDisplayAgencyBanner(timeOpenAgency['lundi'].start,timeOpenAgency['lundi'].end)
                     }
                     break;
                  }

                  case 2: {
                     if(timeOpenAgency['mardi']) {
                       this.checkDisplayAgencyBanner(timeOpenAgency['mardi'].start,timeOpenAgency['mardi'].end)
                     }
                     break;
                  }

                  case 3: {
                     if(timeOpenAgency['mercredi']) {
                       this.checkDisplayAgencyBanner(timeOpenAgency['mercredi'].start,timeOpenAgency['mercredi'].end)
                     }
                     break;
                  }

                  case 4: {
                     if(timeOpenAgency['jeudi']) {
                       this.checkDisplayAgencyBanner(timeOpenAgency['jeudi'].start,timeOpenAgency['jeudi'].end)
                     }
                     break;
                  }

                  case 5: {
                     if(timeOpenAgency['vendredi']) {
                       this.checkDisplayAgencyBanner(timeOpenAgency['vendredi'].start,timeOpenAgency['vendredi'].end)
                     }
                     break;
                  }

                  case 6: {
                     if(timeOpenAgency['samedi']) {
                       this.checkDisplayAgencyBanner(timeOpenAgency['samedi'].start,timeOpenAgency['samedi'].end)
                     }
                     break;
                  }
                }
             }

       })
         .catch((err) => {
             // Handler error
         });
 },
  checkDisplayAgencyBanner(start,end) {
     if(start == end) {
         this.isShowAgencyBanner = true
       } else {
        
           const d = new Date();
           const hour = d.getHours()  ;
           const minute = d.getMinutes();
           const currentDate = (hour < 10 ? ('0'+hour) : hour) + ':' + (minute < 10 ? ('0'+minute) : minute)
           if(currentDate> end || currentDate <start)  {
               this.isShowAgencyBanner = true;
           }
       }
   },
    onClickOutsideUnread() {
     if (this.isShowMarkUnreadBox) 
     {
      this.isShowMarkUnreadBox = false;
      if(!this.info.detail.unreadConversation) {
        this.currentMarkUnreadKey = null;

      }

     }

    },
    onClickUnreadIcon(index) {
      const position = this.$refs[`mark-unread-${index}`][0].getBoundingClientRect();
      this.currentMarkUnreadKey = this.info.detail.content[index].key;
      const screenWidth = window.innerWidth;
      let offsetX = 120;
      // Responsive
      if (screenWidth <= 768) {
        if (position.x < (Math.round(screenWidth / 2) - 50)) {
          offsetX = 50;
        }
        if (position.x > (Math.round(screenWidth / 2) + 50)) {
          offsetX = 160;
        }
      }
      this.$refs['mark-unread-box'].style.transform = `translate(${position.x - offsetX}px, ${position.y+30}px)`;

      setTimeout(() => {
        this.isShowMarkUnreadBox = true
      });
    },
    onMarkUnread() {
      const currentUnreadIndex = this.info.detail.content.findIndex((item)=>item.key ===this.currentMarkUnreadKey);
      if(this.chatContent.length > 0 & currentUnreadIndex!==null && this.chatContent[currentUnreadIndex].sentAt) {
        const logReactBody = {
          idConversation: this.info.detail.id.toString(),
          idUser: this.userCrfId,
          typeAction: LOG_ACTIVITY_TYPE.UNREAD_MESSAGE,
          dtCreateMessage: this.chatContent[currentUnreadIndex].sentAt - 1
        }
        this.isShowMarkUnreadBox = false;
        chatService.logChatActivity(logReactBody).then((res) => {
          this.$emit('click');
          this.updateUnreadMessage()
          if(res && !res.success) {
             this.displayLogChatErrorMessage(res.error)
          }
          
        }).catch((err)=> this.displayLogChatErrorMessage(err.code ||err));
      }
     
    },
    displayLogChatErrorMessage(err) {
     let message = '';
     switch (err){
      case 'err_logs_activity_chat_not_found': {
         message = this.$t('err_logs_activity_chat_not_found');
         break;
       }

       case 'err_invalid_date_time_create_message': {
         message = this.$t('err_invalid_date_time_create_message');
         break;
       }
     }
     this.callToaster(message);
    },
    onchangeMessage(event) {
      this.$emit("changeMessage", event);
    },
    onClickOutside() {
      this.isFocusSendMessageInput = false;
    },
    onFocusSendMessageInput() {
      this.isFocusSendMessageInput = true ;
    },

    formatPersonName(value) {
      let name = value.firstName + " " + value.lastName;
      this.$store.dispatch('SET_LOADING', false)
      switch (value.type) {
        case '1': {
          if (!name.includes(` (${this.$t('adv-role-title')})`)) {
            name = name + ` (${this.$t('adv-role-title')})`;
            return name;
          }
          break;
        }

        case '2': {
          if (!name.includes(` (${this.$t('adv-referer-title')})`)) {
            name = name + ` (${this.$t('adv-referer-title')})`;
            return name;
          }
          break;
        }

        case '3': {
          if (!name.includes(` (${this.$t('client-participant-title')})`)) {
            name = name + ` (${this.$t('client-participant-title')})`;
            return name;
          }
          break;
        }

        case '4': {
          if (!name.includes(` (${this.$t('client-referer-participant-title')})`)) {
            name = name + ` (${this.$t('client-referer-participant-title')})`;
            return name;
          }
        }
        case '5': {
          if (!name.includes(` (${this.$t('agency-participant-title')})`)) {
            name = name + ` (${this.$t('agency-participant-title')})`;
            return name;
          }
          break;

        }
        case '6': {
          if (!name.includes(` (${this.$t('agency-referer-title')})`)) {
            name = name + ` (${this.$t('agency-referer-title')})`;
            return name;
          }
          break;
        }

        case '7': {
          if (!name.includes(` (${this.$t('agency-lead-title')})`)) {
            name = name + ` (${this.$t('agency-lead-title')})`;
            return name;
          }
          break;
        }
      }
    },
    updateUnreadMessage() {
      this.indexUnreadMessage = undefined;
      this.arrayUnreadMessageIndex = [];
      this.numberUnreadMessage = 0;
      let contentReadAt = this.info.detail.members.find((item) => item.idFirebase == this.userIdFirebase).contentReadAt;
      contentReadAt = moment(contentReadAt).valueOf()
      if (this.info.detail.content && this.info.detail.content.length > 0) {
        this.indexUnreadMessage = this.info.detail.content.findIndex((message, index) =>
          message && (Number(message.sentAt) - Number(contentReadAt)) > 0  && !message.isMine)
        const currentUnreadIndex = this.info.detail.content.findIndex((item)=>item.key ===this.currentMarkUnreadKey);
        if(currentUnreadIndex>=0) {
          this.numberUnreadMessage = this.chatContent.length - currentUnreadIndex;
          this.indexUnreadMessage = currentUnreadIndex;
          this.info.detail.content.map((item, index) => {
         
            if ((Number(item.sentAt) - Number(contentReadAt)) > 0 && !item.isMine && this.arrayUnreadMessageIndex && !this.arrayUnreadMessageIndex.includes(index)) {
              if(index < currentUnreadIndex || index > (currentUnreadIndex + this.numberUnreadMessage)) {
                this.numberUnreadMessage = this.numberUnreadMessage + 1;
                this.arrayUnreadMessageIndex.push(index)
              }
              
              }
            })
         } else {
          if(this.info && this.info.detail && this.info.detail.unreadConversation) {
            this.info.detail.content.map((item, index) => {
         
              if ((Number(item.sentAt) - Number(contentReadAt)) >= 0 && this.arrayUnreadMessageIndex && !this.arrayUnreadMessageIndex.includes(index)) {
              
                  this.numberUnreadMessage = this.numberUnreadMessage + 1;
                  this.arrayUnreadMessageIndex.push(index)
              }
              })
              this.indexUnreadMessage = this.numberUnreadMessage>0 ? this.info.detail.content.length - this.numberUnreadMessage : null;
  
          }

         }
          
        
       
      }
      if(this.isFocusSendMessageInput && this.numberUnreadMessage > 0) {
        setTimeout(() => {
          this.onReadMessage();

        }, 1000);
      }
    },
    ...mapActions('chat', [
      'removePendingMsg', 
      'addPendingMsg', 
      'sendPendingMsgs', 
      'setCurrentConversation', 
      'getChatSettings'
    ]),
    scrollToBottom(id) {
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollTop = el.scrollHeight;
          el.animate({
            scrollTop: el.scrollHeight
          });
        }
      });
    },
    scrollToElement(id) {
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView()
        }
      });
    },
    onReadMessage() {
      if(this.numberUnreadMessage >0) {
        this.numberUnreadMessage = 0;
        this.currentMarkUnreadKey =null;
        this.indexUnreadMessage = undefined;
        this.arrayUnreadMessageIndex = [];
        const logReactBody = {
          idConversation: this.info.detail.id.toString(),
          idUser: this.userCrfId,
          typeAction: LOG_ACTIVITY_TYPE.READ_MESSAGE
        }
        chatService.logChatActivity(logReactBody).then((res) => {
          this.$emit('click');
          if(res && !res.success) {
            this.displayLogChatErrorMessage(res.error)
         }
         
       }).catch((err)=> this.displayLogChatErrorMessage(err.code ||err));
        this.currentMarkUnreadKey = null;
      }
     
    },
    urlify(text) {
      var urlRegex = /(https?:\/\/[^\s]+)/g;
      return text.replace(urlRegex, function (url) {
        return '<a target="_blank" rel="noopener noreferrer" href="' + url + '">' + url + '</a>';
      })
    },
    _uploadFile(event) {
      const files = event.target.files;
      [...files].forEach(file => {
        const {
          name,
          size,
          type
        } = file
        this.uploadFile(file, IMAGE_MIME_TYPES, this.chatSettings.totalMaxImages).then(reader => {
          reader.onload = (e) => {
            this.previewImgs.push({
              file: file,
              name,
              size,
              type,
              preview: e.target.result
            });
          };
          reader.readAsDataURL(file);
        }).catch(err => {
          this.$refs['uploadFile'].value = null;
          if (err === FILE_ERROR.MAX_SIZE) {
            this.callToaster(this.$t('upload-file-max-size-alert').replace('[fileSize]', this.chatSettings.totalMaxImages));
          }
          if (err === FILE_ERROR.INVALID_MIME) {
            this.callToaster(this.$t('apply-candidate-cv-invalid-file'));
          }
        });
      })
      this.$refs['uploadFile'].value = null;
    },
    removePreviewImg(index) {
      this.previewImgs.splice(index, 1);
    },
    selectMessage(message) {
      this.currentMsg = message;
    },
    showConfirmPopup(message, action) {
      this.currentMsg = message;
      this.currentAction = action;
      if (action === 'remove') {
        this.confirmPopup = {
          message: this.$t('remove-message-confirm'),
          closeBtn: this.$t('cancel-btn'),
          submitBtn: this.$t('nagora-yes-btn')
        }
      }
      this.$bvModal.show('confirmModal');
    },
    onConfirmPopup() {
      if (this.currentAction === 'remove') {
        this.removeAMessage();
      }
      this.hideModal();
    },
    removeAMessage() {
      firebase
        .database()
        .ref(`${refMessage}/${this.roomId}/${this.currentMsg.key}/deleted`)
        .set(true);
      const logDeleteBody = {
          idConversation: this.info.detail.id.toString(),
          idUser: this.userCrfId,
          typeAction: LOG_ACTIVITY_TYPE.DELETE_MESSAGE
      }
      this.onchangeMessage(true)
      chatService.logChatActivity(logDeleteBody).then((res)=> {
        if(res && !res.success) {
          this.displayLogChatErrorMessage(res.error)
       }
       
     }).catch((err)=> this.displayLogChatErrorMessage(err));
    },
    hideModal() {
      this.confirmPopup = {
        message: '',
        closeBtn: '',
        submitBtn: ''
      };
      this.$bvModal.hide('confirmModal');
    },
    selectEmoji(emoji) {
      this.message += emoji.emoji.unicode;
    },
    openEmojiBox() {
      setTimeout(() => {
        this.showEmojiBox = !this.showEmojiBox
      });
    },
    checkIsPending(item) {
      const firebasePath = `${refMessage}/${this.roomId}`;
      return this.pendingMsgs[firebasePath] && this.pendingMsgs[firebasePath].filter(mess => mess.sentAt === item.sentAt).length
    },
    displayTime(index) {
      const date = new Date(
        this.chatContent[index].sentAt
      ).setHours(0, 0, 0, 0);
      if (index === 0) {
        return this.getDisplayTime(date);
      } else {
        const dateBefore = new Date(
          this.chatContent[index - 1].sentAt
        ).setHours(0, 0, 0, 0);
        if (dateBefore < date) {
          return this.getDisplayTime(date);
        }
      }
    },
    getSentTime(date) {
      return moment(date).format("LT");
    },
    sendMsg(e) {
      e.preventDefault();
      if (this.userStatus == MEMBER_STATUS.BLOCKED) {
        this.alert.message = this.$t('discussion-block-alert-text');
        this.$refs['alertPopup'].show();
      } else {
        const memberInfo = this.info.detail.members.find(member => member.idFirebase === this.userIdFirebase);
        const text = this.isScriptTag(this.message.trim()) ? this.message.trim() : this.urlify(this.message.trim());
        const rawText = this.message.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
        const pendingMsgs = {
          sentAt: new Date().getTime(),
          sentBy: `usr-${this.userCrfId}`,
          text: text || '',
          rawText: rawText || '',
          files: this.previewImgs,
          reactions: null,
          replyMessage: null,
          seen: false,
          memberId: memberInfo.id,
          conversationId: this.info.detail.id
        };

        if (this.message.trim() || this.previewImgs.length) {
          this.info.detail.content.push({
            ...pendingMsgs,
            userInfo: this.userInfo,
            isMine: true
          });
          this.addPendingMsg({
            msg: pendingMsgs,
            path: `${refMessage}/${this.roomId}`
          });
          if (!this.isDisconnected) {
            this.sendPendingMsgs({path:`${refMessage}/${this.roomId}`, conversationId:this.info.detail.id});
          }
          this.message = "";
          this.$emit("changeMessage", this.message);
          this.previewImgs = [];
          this.scrollToBottom("chatBox");
        }
      }
    },
    sendMsgToFirebase(msg) {
      let newData = firebase
        .database()
        .ref(`${refMessage}/` + this.roomId)
        .push();
      newData.set(msg);
    },
    formatTime(time) {
      if (time >= this.getDateBefore(7).getTime()) {
        return moment(time).format("dddd");
      } else {
        return moment(time).format("LL");
      }
    },
    getDefaultImg() {
      return require('@/assets/avatar-male.png');
    },
    handleEnter(e) {
      const isEnter = e.which === 13;
      const isShiftEnter = (e.which === 13) && e.shiftKey;

      if (isShiftEnter) {
        return;
      }
      if (isEnter) {
        this.sendMsg(e);
      }
    },
    showReactBox(index) {
      const position = this.$refs[`reactBtn-${index}`][0].getBoundingClientRect();
      const screenWidth = window.innerWidth;
      let offsetX = 120;
      // Responsive
      if (screenWidth <= 768) {
        if (position.x < (Math.round(screenWidth / 2) - 50)) {
          offsetX = 50;
        }
        if (position.x > (Math.round(screenWidth / 2) + 50)) {
          offsetX = 160;
        }
      }
      this.$refs['react-emoji-box'].style.transform = `translate(${position.x - offsetX}px, ${position.y - 55}px)`;
       
      setTimeout(() => {
        this.isShowReactBox = true
      });
      this.currentMsgIndex = index;
      this.currentMsg = this.chatContent[index];
    },
    reactMsg(code) {
      const reactObj = {
        id: this.userIdFirebase,
        name: this.$options.filters.personName(this.userInfo)
      };
      const reactEmojis = this.chatContent[this.currentMsgIndex].reactions;
      let currentReact = null;
      let formatEmoji = null;
      if (reactEmojis) {
        formatEmoji = Object.keys(reactEmojis).find(emoji => emoji.codePointAt(0) === code.codePointAt(0))
      }
      if (reactEmojis) {
        Object.keys(reactEmojis).forEach(emoji => {
          const deleteIndex = reactEmojis[emoji].findIndex(react => react.id === this.userIdFirebase)
          if (deleteIndex !== -1) {
            currentReact = emoji.codePointAt(0);
            firebase
              .database()
              .ref(`${refMessage}/${this.roomId}/${this.currentMsg.key}/reactions/${emoji}/${reactEmojis[emoji][deleteIndex].key}`)
              .set(null);
          }
        })
      }
      if (currentReact !== code.codePointAt(0)) {
        if (formatEmoji) {
          firebase
            .database()
            .ref(`${refMessage}/${this.roomId}/${this.currentMsg.key}/reactions/${formatEmoji}`)
            .push(reactObj);
        } else {
          firebase
            .database()
            .ref(`${refMessage}/${this.roomId}/${this.currentMsg.key}/reactions/${code}`)
            .push(reactObj);
        }



        const logReactBody = {
          idConversation: this.info.detail.id.toString(),
          idUser: this.userCrfId,
          nbMessages: 0,
          nbReacts: 1,
          typeAction: LOG_ACTIVITY_TYPE.REACT
        }
        this.onchangeMessage(true)
        chatService.logChatActivity(logReactBody).then((res)=> {
          if(res && !res.success) {
            this.displayLogChatErrorMessage(res.error)
         }
         
       }).catch((err)=> this.displayLogChatErrorMessage(err.code ||err));
      }
      this.isShowReactBox = false;
    },
    showReactList(content, emoji) {
      this.currentReactMsgHover = content.reactions[emoji];
      const position = this.$refs[`emoji-${content.sentAt}${emoji}`][0].getBoundingClientRect();
      const screenWidth = window.innerWidth;
      let offsetX = 50;
      // Responsive
      if (screenWidth <= 768) {
        if (position.x < (Math.round(screenWidth / 2) - 50)) {
          offsetX = 50;
        }
        if (position.x > (Math.round(screenWidth / 2) + 50)) {
          offsetX = 100;
        }
      }
      this.$refs['react-msg-box'].style.transform = `translate(${position.x - offsetX}px, ${position.y + 30}px)`;
    },
    resetModal(e) {
      this.isShowReactBox = false;
      this.currentReactMsgHover = null;
      this.handleScroll()
    }
  }
}